var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 92",
    width: 68,
    height: 92,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 66,
    height: 90,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABaAQMAAAA2HxJdAAAAAXNSR0IB2cksfwAAAAZQTFRFxMTEAAAAyqTSJwAAAAJ0Uk5T/wDltzBKAAAARklEQVR4nGNkgAFGGrLqG9k/ctg7NtCHNbRdT21/DHXXM78VgJrM/5YFypK/C2fdZ8Jg2e+Hsw4wksliYACyoG4hnUWaLwFa15NbRR0vtQAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 1,
    y: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.fc2371a0885fd41dea69bfe267eb0a04.svg";
export { ForwardRef as ReactComponent };